<template lang="pug">
ul.menu
    li.menu__item(
        v-for="link in links"
        :key="link.url"
    )
        MenuItem(
            :link="link"
        )
</template>

<script>
import MenuItem from './MenuItem.vue';

export default {
  name: 'Menu',

  components: {
    MenuItem,
  },

  data() {
    return {
      links: [
        {
          url: '/promo',
          name: 'Акции',
        },
        {
          url: '/banks',
          name: 'Банки',
        },
        {
          url: '/districts',
          name: 'Районы',
        },
        {
          url: '/developers',
          name: 'Застройщики',
        },
        {
          url: '/residentials',
          name: 'Жилые комплексы',
        },
        {
          url: '/advantage-companies',
          name: 'Преимущества компании',
        },
        {
          url: '/advantage-objects',
          name: 'Преимущества объекта',
        },
        {
          url: '/repairs',
          name: 'Каталог ремонтов',
        },
        {
          url: '/posts',
          name: 'Блог компании',
        },
        {
          url: '/digital',
          name: 'Digital',
        },
        {
          url: '/city',
          name: 'Город',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.menu {
    list-style: none;
    padding: 0;
}
</style>
